<script>
  import { slide } from 'svelte/transition';
  import { getDateText } from '../../../common/dates';
  import { getInstagramData } from '../../../api/Scribble/query';
  export let item;

  let instaHTML;
  let twitterHTML = '';
  let video;
  let article;

  $: item;
  $: video && handleVideo();
  $: instaHTML && instgrm.Embeds.process();
  $: twitterHTML && twttr.widgets.load();
  $: article && handleArticle();

  const isTwitter = () => item.Content.indexOf('twitter.com') > 1;

  const isVideo = () => {
    if (item.Content.indexOf('video-assetId') > 1) {
      video = true;
      return true;
    } else {
      false;
    }
  };

  const isArticle = () => {
    if (item.Content.indexOf('article-title') > 1) {
      article = true;
      return true;
    } else {
      return false;
    }
  };
  const isInstagram = () => {
    let regex = new RegExp('(https?://(?:www.)?instagram.com/p/([^/?#&]+)).*');
    return regex.test(item.Content);
  };

  const handleTwitter = async () => {
    twitterHTML = item.Content;
    return false;
  };

  const handleInstagram = async () => {
    let anchorText = item.Content.match(
      /(https?:\/\/(?:www\.)?instagram\.com\/p\/([^/?#&]+)).*/
    )[1];
    let noQueryParams = anchorText.split('?');
    try {
      const res = await getInstagramData(noQueryParams[0]);
      if (res && res.html) {
        instaHTML = res.html;
        return true;
      }
    } catch (e) {
      instaHTML = item.Content;
      return false;
    }
  };

  const handleVideo = () => {
    const article = document.getElementById(item.Id);
    if (article) {
      let assetId = article.getElementsByClassName('video-assetId');
      if (assetId.length && window.playVideo) {
        window.playVideo({
          container: item.Id,
          assetId: assetId[0].innerHTML,
          showAds: false,
          autoplay: false
        });
      }
    }
  };

  const handleArticle = () => {
    const article = document.getElementById(item.Id);
    if (article) {
      let articleTitle = article.getElementsByClassName('article-title');
      let articleUrl = document.getElementsByClassName('article-published-url');
      let existing = document.getElementsByClassName(item.Id);
      if (articleTitle.length && !existing.length) {
        let div = document.createElement('div');
        div.className = item.Id;
        let text = document.createElement('span');
        let link = document.createElement('a');
        text.innerHTML = 'Artikkel: ';
        text.style.fontWeight = '700';
        text.style.marginLeft = '0.3rem';
        link.href = articleUrl[0].innerHTML;
        var linkText = document.createTextNode(articleTitle[0].innerHTML);
        link.appendChild(linkText);
        div.append(text, link);
        articleTitle[0].parentElement.appendChild(div);
      }
    }
  };
</script>

<style src="feeditem.scss">
</style>

{#if item && item.Type !== 'POLL'}
  <article class="feed-item" id={item.Id} in:slide>
    <div class="title">
      <span class="red-text">{getDateText(item.CreationDate)}</span>
      <div class="byline">
        {(item.Creator && item.Creator.Name) || ''}
        {#if item.Creator && item.Creator.Avatar}
          <div
            class="avatar"
            style={`background-image: url(${item.Creator.Avatar})`} />
        {/if}
      </div>
    </div>
    <div class="content" class:videoplayer={isVideo()}>
      {#if isInstagram() && handleInstagram()}
        <div class={`instagram_${item.Id} insta`}>
          {@html instaHTML}
        </div>
      {:else if isTwitter() && handleTwitter()}
        <div class={`twitter_${item.Id} twitter`}>
          {@html twitterHTML}
        </div>
      {:else if isArticle()}
        {@html item.Content}
      {:else}
        {@html item.Content}
      {/if}
      {#if isVideo() && window.playVideo}
        <div id={`video_placeholder_${item.Id}`}>
          <!-- svelte-ignore a11y-media-has-caption -->
          <video id={`video_${item.Id}`} />
        </div>
      {:else if isVideo()}
        <div class="padded-box">
          <p class="error">Videospiller ikke funnet</p>
        </div>
      {/if}
      {#if getDateText(item.CreationDate) !== getDateText(item.LastModifiedDate)}
        <div class="updated">
          Oppdatert
          {getDateText(item.LastModifiedDate)}
        </div>
      {/if}
    </div>
  </article>
{/if}
